import type { LucideIcon } from "lucide-react";
import {
  CalendarHeart,
  Camera,
  CarFront,
  Clock3,
  HelpCircle,
  Hotel,
  Mail,
  MapPin,
  MessageCircleHeart,
  Music2,
  Sparkles,
  Utensils,
} from "lucide-react";

export const navItems = [
  { href: "#informacje", label: "Informacje" },
  { href: "#miejsce", label: "Miejsce" },
  { href: "#plan", label: "Plan dnia" },
  { href: "#potwierdzenie", label: "Potwierdzenie" },
  { href: "#galeria", label: "Galeria" },
  { href: "#faq", label: "Odpowiedzi" },
  { href: "#pytania", label: "Pytania" },
] as const;

export type InfoCard = {
  icon: LucideIcon;
  label: string;
  title: string;
  text: string;
};

export const infoCards: InfoCard[] = [
  {
    icon: CalendarHeart,
    label: "Data",
    title: "10 lipca 2027",
    text: "Zarezerwujcie sobotę 10 lipca. Dokładną godzinę rozpoczęcia podamy, gdy tylko będzie ustalona.",
  },
  {
    icon: MapPin,
    label: "Miejsce",
    title: "La Palette Garden",
    text: "Ceremonia i przyjęcie odbędą się przy ul. Gustawa Morcinka 40 w Krakowie.",
  },
  {
    icon: Sparkles,
    label: "Klimat",
    title: "Elegancko i swobodnie",
    text: "Najważniejsze, żeby było wygodnie — do rozmów, zdjęć i tańca. Szczegóły dress code'u dopiszemy razem z zaproszeniami.",
  },
  {
    icon: Mail,
    label: "Potwierdzenie",
    title: "RSVP na stronie",
    text: "Potwierdźcie obecność i od razu dajcie nam znać o noclegu, diecie oraz potrzebnym transporcie.",
  },
];

export type TimelineItem = {
  icon: LucideIcon;
  time: string;
  title: string;
  text: string;
};

export const timeline: TimelineItem[] = [
  {
    icon: Clock3,
    time: "Godzina wkrótce",
    title: "Ceremonia",
    text: "Spotkamy się w ogrodzie La Palette Garden. Dokładną godzinę rozpoczęcia podamy później.",
  },
  {
    icon: Camera,
    time: "Po ceremonii",
    title: "Życzenia i zdjęcia",
    text: "Zaplanujemy spokojny moment na wspólne zdjęcia i pierwsze rozmowy.",
  },
  {
    icon: Utensils,
    time: "Wieczór",
    title: "Przyjęcie",
    text: "Po ceremonii zostajemy na miejscu na kolację, toasty i wspólne świętowanie.",
  },
  {
    icon: Music2,
    time: "Noc",
    title: "Taniec i powroty",
    text: "Bawimy się do rana. Autobusy powrotne do Wolbromia planujemy o 00:00, 02:30 i 04:30.",
  },
];

export type Feature = {
  icon: LucideIcon;
  title: string;
  text: string;
};

export const guestFeatures: Feature[] = [
  {
    icon: CarFront,
    title: "Dojazd",
    text: "La Palette Garden znajduje się przy ul. Gustawa Morcinka 40 w Krakowie. W formularzu możecie zamówić autobus z Wolbromia.",
  },
  {
    icon: Hotel,
    title: "Nocleg",
    text: "Zaznaczcie w potwierdzeniu obecności, czy potrzebujecie noclegu. Pomoże nam to zaplanować rezerwacje.",
  },
  {
    icon: MessageCircleHeart,
    title: "Powrót do Wolbromia",
    text: "Planujemy trzy kursy powrotne: o 00:00, 02:30 i 04:30. Wybraną godzinę zaznaczycie w RSVP.",
  },
];

export type FaqItem = {
  question: string;
  answer: string;
};

export const faqItems: FaqItem[] = [
  {
    question: "Kiedy i gdzie odbędzie się uroczystość?",
    answer:
      "Ceremonia i przyjęcie odbędą się w sobotę 10 lipca 2027 w La Palette Garden przy ul. Gustawa Morcinka 40 w Krakowie. Godzinę rozpoczęcia podamy później.",
  },
  {
    question: "Jak potwierdzić obecność?",
    answer:
      "Wypełnij formularz potwierdzenia na tej stronie. Wpisz imiona wszystkich zgłaszanych osób i odpowiedz na krótkie pytania organizacyjne.",
  },
  {
    question: "Czy będzie zorganizowany transport?",
    answer:
      "Planujemy autobus z Wolbromia do Krakowa oraz kursy powrotne do Wolbromia o 00:00, 02:30 i 04:30. W formularzu wybierz potrzebne przejazdy albo zaznacz, że nie potrzebujesz transportu.",
  },
  {
    question: "Co z noclegiem i alergiami pokarmowymi?",
    answer:
      "Daj nam znać o potrzebie noclegu i wszystkich alergiach pokarmowych w formularzu RSVP. Te odpowiedzi pomogą nam przygotować rezerwacje i menu.",
  },
  {
    question: "Czy na stronie będzie galeria zdjęć?",
    answer:
      "Tak. Teraz jest przygotowana sekcja galerii, a po ślubie dodamy zdjęcia i najważniejsze wspomnienia.",
  },
  {
    question: "Gdzie zadawać pytania organizacyjne?",
    answer:
      "Najwygodniej przez formularz w sekcji pytań. Wszystkie wiadomości ze strony trafiają do nas tą drogą.",
  },
];

export const galleryItems = [
  {
    title: "Zaproszenia",
    text: "Miejsce na pierwsze zdjęcia detali.",
  },
  {
    title: "Przygotowania",
    text: "Tu dodamy kadry z dnia ślubu.",
  },
  {
    title: "Goście",
    text: "Po weselu pojawią się wspólne wspomnienia.",
  },
] as const;

export const checklistItems = [
  "Zapisać datę: sobota, 10 lipca 2027",
  "Potwierdzić obecność wszystkich zgłaszanych osób",
  "Zaznaczyć potrzebny nocleg i ewentualne alergie",
  "Wybrać transport z Wolbromia i godzinę powrotu",
] as const;

export const returnTransportOptions = [
  { value: "00:00", label: "Powrót o 00:00" },
  { value: "02:30", label: "Powrót o 02:30" },
  { value: "04:30", label: "Powrót o 04:30" },
  { value: "none", label: "Nie potrzebuję transportu powrotnego" },
] as const;

export const sectionIcons = {
  faq: HelpCircle,
};
